import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

export function emailValidator(translate: TranslateService): ValidatorFn {
  const EMAIL_REGEXP =
    /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === '') return null;

    return EMAIL_REGEXP.test(value)
      ? null
      : { email: translate.instant('VALIDATION.EMAIL_INVALID') };
  };
}
